module.exports = "../fonts/HelveticaNeueLTW01-35Thin.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-35Thin.eot
// module id = Wo5r
// module chunks = 1